export default __webpack_public_path__ + "static/media/lightSensor.c8761575.svg";